import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { audit, Observable, of } from 'rxjs';
import { APIResponse } from '../models/models';
//import { DataCollection } from '../models/models';

@Injectable()
export class UtilService {
    public isLoading: boolean = false;
    private auditNotes: string = "";

    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    }

    public obs(key: string, url: string): Observable<any> {
        var json = localStorage.getItem(key);
        if (json != null) {
            var obj = JSON.parse(json);
            return of<any>(obj);
        }
        else {
            this.http.get<any>(url).subscribe(result => {
                json = JSON.stringify(result);
                localStorage.setItem(key, json);
            });
            return this.http.get<any>(url);
        }
    }

    //private xobs(json: string): Observable<ApplicationControl[]> {
    //    var obj = JSON.parse(json) as ApplicationControl[];
    //    return of<ApplicationControl[]>(
    //        obj
    //    );
    //}

    public getEmployeeID() {
        var lsEmployeeID = localStorage.getItem('EmployeeId');
        if (lsEmployeeID != null && lsEmployeeID != "") {
            return parseInt(lsEmployeeID);
        }
        else {
            return -2;
        }
    }

    public getPageTypeName(pageType: string) {
        var pageTypeName: string = "";
        if (pageType == "carriersales") {
            pageTypeName = "Carrier Sales";
        }
        else if (pageType == "procurement") {
            pageTypeName = "Procurement";
        }
        else if (pageType == "orderentry") {
            pageTypeName = "Order Entry";
        }
        else if (pageType == "tracking") {
            pageTypeName = "Tracking";
        }
        else if (pageType == "crossborder") {
            pageTypeName = "Cross Border";
        }
        return pageTypeName;
    }

    public setAuditNotes(auditNotes: string) {
        this.auditNotes = auditNotes;
    }

    public getAuditNotes() {
        return this.auditNotes;
    }

    public isValidURL(url: string) {
        var isValid = true;
        if (url == "") {
            isValid = true;
        }
        else {
            if (!url.startsWith("http://") && !url.startsWith("https://")) {
                isValid = false;
            }
            if (url.indexOf(".") < 1) {
                isValid = false;
            }
            if (isValid) {
                try {
                    new URL(url);
                    isValid = true;
                } catch (error) {
                    isValid = false;
                }
            }
        }
        return isValid;
    }
    public getBaseUrl() {
        return this.baseUrl;
    }

    public getDateDimensionBusinessDaysAfterDate(afterDate: Date, numDays: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/DateDimension/GetDateDimensionBusinessDaysAfterDate/?afterDate=' + afterDate.toDateString() + '&numDays=' + numDays);
    }

    public getDateAsUTC(date: Date) {
        // Purpose: for saving UI data as typed into the database instead of ISO 8601 auto-conversion to UTC
        //new Date(this.shipperEarliestDate.toISOString().replace("T", " ").split(".")[0]);
        //return date;
        return new Date(date.toLocaleString() + ' UTC');
    }

    public getUTCDateAsLocalDate(date: Date) {
        // Purpose: for saving UI data as typed into the database instead of ISO 8601 auto-conversion to UTC
        //new Date(this.shipperEarliestDate.toISOString().replace("T", " ").split(".")[0]);
        //return date;
        return new Date(date.toString() + ' UTC').toLocaleString();
    }

    public getLocalDateInTimeZone(date: Date, tz: string) {
        return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tz }));   
    }

    public getTimeZoneDateAsLocalDate(date: Date, tz: string) {
        var tzOffset = this.getTimeZoneOffset(date, tz);
        var localOffset = this.getLocalTimeZoneOffset(date);
        var offset = localOffset - tzOffset;
        return this.addHours(date, offset);
    }

    public getLocalDateInUTC(date: Date) {
        return this.getLocalDateInTimeZone(date, "UTC");
    }

    public getLocalTimeZoneOffset(date: Date) {
        var utcDate = new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: 'UTC' }));
        var tzDate = new Date((typeof date === "string" ? new Date(date) : date));
        var offset = 0 - this.getDateDiffHours(utcDate, tzDate);
        return offset;
    }

    public getTimeZoneOffset(date: Date, tz: string) {
        var utcDate = new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: 'UTC' }));
        var tzDate = new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tz }));
        var offset = 0 - this.getDateDiffHours(utcDate, tzDate);
        return offset;
    }

    public getCheckCallDateTime(date: Date) {
        var ret = "";
        ret += date.getUTCMonth() + 1;
        ret += "/";
        ret += date.getUTCDate();
        ret += "/";
        ret += date.getUTCFullYear();
        ret += ", ";
        ret += date.getUTCHours() + ":";
        ret += (date.getUTCMinutes() > 9 ? date.getUTCMinutes() : "0" + date.getUTCMinutes());
        ret += " ";
        ret += (date.getUTCHours() >= 12 ? "PM" : "AM");
        return ret;
    }

    public getDateDiffSec(fromDate: Date, toDate: Date) {
        var origDate = new Date(fromDate).getTime();
        var newDate = new Date(toDate).getTime();
        var diffMsec = Math.abs(newDate - origDate);
        var diffSec = diffMsec / 1000;
        //console.log(origDate, newDate, diffMsec, diffSec, diffMin);
        return diffSec;
    }

    public getDateDiffMin(fromDate: Date, toDate: Date) {
        var diffSec = this.getDateDiffSec(fromDate, toDate);
        return diffSec / 60;
    }

    public getDateDiffHours(fromDate: Date, toDate: Date) {
        var diffMin = this.getDateDiffMin(fromDate, toDate);
        return diffMin / 60;
    }

    public getDateDiffDays(fromDate: Date, toDate: Date) {
        var origDate = new Date(fromDate.getTime());
        var newDate = new Date(toDate.getTime());
        origDate.setHours(0, 0, 0, 0);
        newDate.setHours(0, 0, 0, 0);
        var diffHr = this.getDateDiffHours(origDate, newDate);
        return diffHr / 24;
    }

    public addDays(date: Date, days: number) {
        var result = new Date(date);
        var newDate = new Date(result.getTime() + days * 24 * 60 * 60 * 1000);
        return newDate;
    }

    public addHours(date: Date, hours: number) {
        var result = new Date(date);
        var newDate = new Date(result.getTime() + hours * 60 * 60 * 1000);
        return newDate;
    }

    public addMinutes(date: Date, minutes: number) {
        var result = new Date(date);
        var newDate = new Date(result.getTime() + minutes * 60 * 1000);
        return newDate;
    }

    public addSeconds(date: Date, seconds: number) {
        var result = new Date(date);
        var newDate = new Date(result.getTime() + seconds * 1000);
        return newDate;
    }

    public getTextAreaRows(txt: string) {
        var rows: number = 3;
        if (txt == null) {
            rows = 3;
        }
        else if (txt.length > 60) {
            rows = Math.ceil(txt.length / 60);
        }
        return rows;
    }
}
